var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.208252 2.54167C0.208252 1.43704 1.10362 0.541672 2.20825 0.541672H7.62492C7.82383 0.541672 8.0146 0.620689 8.15525 0.761342L13.5719 6.17801C13.7126 6.31866 13.7916 6.50943 13.7916 6.70834V15.4583C13.7916 16.563 12.8962 17.4583 11.7916 17.4583H2.20825C1.10362 17.4583 0.208252 16.563 0.208252 15.4583V2.54167ZM2.20825 2.04167C1.93205 2.04167 1.70825 2.26547 1.70825 2.54167V15.4583C1.70825 15.7345 1.93205 15.9583 2.20825 15.9583H11.7916C12.0678 15.9583 12.2916 15.7345 12.2916 15.4583V7.45834H8.87492C7.77029 7.45834 6.87492 6.56297 6.87492 5.45834V2.04167H2.20825ZM8.37492 3.10233L11.2309 5.95834H8.87492C8.59871 5.95834 8.37492 5.73454 8.37492 5.45834V3.10233ZM3.54158 10.0417C3.54158 9.62746 3.87737 9.29167 4.29158 9.29167H9.70825C10.1225 9.29167 10.4583 9.62746 10.4583 10.0417C10.4583 10.4559 10.1225 10.7917 9.70825 10.7917H4.29158C3.87737 10.7917 3.54158 10.4559 3.54158 10.0417ZM3.54158 12.9583C3.54158 12.5441 3.87737 12.2083 4.29158 12.2083H8.04158C8.4558 12.2083 8.79158 12.5441 8.79158 12.9583C8.79158 13.3726 8.4558 13.7083 8.04158 13.7083H4.29158C3.87737 13.7083 3.54158 13.3726 3.54158 12.9583Z",
    fill: "#191919"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIcon);
export default __webpack_public_path__ + "static/media/document-icon.741af36d09a3882716b482fddfeb9993.svg";
export { ForwardRef as ReactComponent };